import { createMatch } from "helpers/string"
import type { Thread } from "connected-components/ai-teammate/types/thread"
import { markdownToPlainText } from "./markdown-to-plain-text"

// Local, client-side filter over the loaded list. Matches a case-insensitive substring against the
// DISPLAYED (markdown-stripped) title — the same text the row renders — so what-you-see is what-matches.
// An empty/whitespace query returns the full list (a fresh array, safe to partition further).
export function filterThreadsByQuery(threads: readonly Thread[], query: string): Thread[] {
  const needle = query.trim()
  if (!needle) return threads.slice()
  const matches = createMatch(needle)
  return threads.filter((thread) => matches(markdownToPlainText(thread.title)))
}
